import React from 'react';
import { Col, Container, Card, Row} from 'react-bootstrap';
import { Link, HashRouter as Router, Route, Routes } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import Calculator from './components/Calculator';
import Printable from './components/Printable';
import SaveLoad from './components/SaveLoad';
import reducers from './reducers';
import './index.css';

const createStoreWithMiddleware = applyMiddleware()(createStore);
const store = createStoreWithMiddleware(reducers);

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <Container>
                <Row>
                    <Col md={12}>
                        <Card className='nav-container'>
                            <p className="title" style={{marginBottom: '0px'}}>OnShift Engage Reward Points Calculator</p>
                            <div className='nav-buttons'>
                                <span className='nav-btn'><Link to={`/calculator`} className="btn btn-default">Calculator</Link></span>
                                <span className='nav-btn'><Link to={`/printable`} className="btn btn-default">Printable</Link></span>
                                <span className='nav-btn'><Link to={`/saveLoad`} className="btn btn-default">Save/Load</Link></span>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Routes>
                    <Route path={`/`} element={<Calculator />} />
                    <Route path={`/calculator`} element={<Calculator />} />
                    <Route path={`/printable`} element={<Printable />} />
                    <Route path={`/saveLoad`} element={<SaveLoad />} />
                </Routes>
            </Container>
        </Router>
    </Provider>,
    document.getElementById('root')
);
